import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, Moon, Sun, Phone, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/site/Logo";
import { useTheme } from "@/context/AppContext";
import { COMPANY } from "@/lib/data";

const NAV = [
  ["Home", "/"], ["Services", "/services"], ["Cities", "/cities"], ["Become Partner", "/partner"], ["Track Booking", "/track"],
  ["Blogs", "/blogs"], ["About", "/about"], ["Contact", "/contact"],
];

export const Header = () => {
  const { dark, toggle } = useTheme();
  const [open, setOpen] = useState(false);
  const linkCls = ({ isActive }) => `px-3 py-2 rounded-full text-sm font-medium transition-colors ${isActive ? "text-primary bg-secondary" : "text-foreground/75 hover:text-primary"}`;
  return (
    <header className="sticky top-0 z-40 bg-background/80 backdrop-blur-xl border-b border-border/60" data-testid="site-header">
      <div className="container-x flex h-16 items-center justify-between gap-4">
        <Logo className="h-9 sm:h-10" />
        <nav className="hidden lg:flex items-center gap-1" aria-label="Main">
          {NAV.map(([l, to]) => (
            <NavLink key={to} to={to} end={to === "/"} className={linkCls} data-testid={`nav-${l.toLowerCase().replace(/\s/g, "-")}`}>{l}</NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <a href={COMPANY.phoneHref} className="hidden 2xl:inline-flex items-center gap-2 text-sm font-semibold text-foreground/80 hover:text-primary" data-testid="header-phone">
            <Phone className="h-4 w-4" /> {COMPANY.phone}
          </a>
          <Button variant="ghost" size="icon" onClick={toggle} aria-label="Toggle dark mode" data-testid="theme-toggle" className="rounded-full">
            {dark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
          </Button>
          <Button asChild className="hidden sm:inline-flex rounded-full px-5" data-testid="header-book-btn">
            <Link to="/book">Book Service</Link>
          </Button>
          <Button variant="ghost" size="icon" className="lg:hidden rounded-full" onClick={() => setOpen((o) => !o)} aria-label="Menu" data-testid="mobile-menu-toggle">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </Button>
        </div>
      </div>
      {open && (
        <nav className="lg:hidden border-t border-border bg-background fade-up" data-testid="mobile-menu">
          <div className="container-x py-4 grid gap-1">
            {[...NAV, ["PIN Code Finder", "/pincode-finder"], ["Warranty", "/warranty"], ["Help Center", "/help"], ["Book Service", "/book"]].map(([l, to]) => (
              <NavLink key={to} to={to} end={to === "/"} onClick={() => setOpen(false)} className={linkCls} data-testid={`mobile-nav-${l.toLowerCase().replace(/\s/g, "-")}`}>{l}</NavLink>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
};
